module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/banner/zh-hans-19699a07296124d849f0e4f610ee4fbc.jpg";